import getMime from 'name2mime';

import callApi, { callExternalApi } from './apiCaller';
import { uploadFile as s3UploadFile, getFile as s3GetFile, streamFile, listFiles, deleteFile as s3DeleteFile } from './aws/s3';

import { notifyError } from '../components/Error/ErrorBoundary';

export const S3_ENCRYPTION_ALGORYTHM = 'AES256';
export const SIGNED_URL_DEFAULT_EXPIRES = 24 * 60 * 60;

export function getFileUrl(filename, userId = null, onProgress = null, isFromProvider = false) {
	return new Promise((resolve, reject) => {
		getFileContent(filename, userId, false, onProgress, isFromProvider).then(result => {
			let fileUrl = '';
			// console.log('getFileUrl', filename, userId, result.content, result.url);
			if(result.content) {
				const { type } = getMime(filename);
				fileUrl = URL.createObjectURL(new Blob([result.content], { type: result.contentType || type }));
			} else if(result.url) {
				fileUrl = result.url;
			}
			resolve(fileUrl);
		}).catch(error => {
			console.error('getFileUrl', error);
			notifyError(error, { filename, userId });
			reject(error);
		});
	});
}

export function getFileContent(filename, userId = null, forceContent = false, onProgress = null, isFromProvider = false) {
	return new Promise((resolve, reject) => {
		// Retrieve file from API server or from Provider (S3)
		if(isFromProvider) {
			callApi(`file/get/url/${filename}${userId ? `?user=${userId}` : ''}`).then(result => {
				if(result.url) {
					if(result.encodingKey || forceContent) {
						// Does not work without credential
						// streamFile(filename, result.encodingKey, {}, true).then(result => {
						//     console.log(result);
						//     console.log(result.transformToWebStream());
						//     result.transformToWebStream().then(console.log)

						//     // result.Body.transformToString('base64').then(content => {
						//     //     // console.log('Result from s3 get file', result, content);
						//     //     // resolve({
						//     //     //     content,
						//     //     //     contentType: result.ContentType,
						//     //     // });
						//     //     resolve({
						//     //         url: `data:${result.ContentType};base64,${content}`,
						//     //     });
						//     // });

						//     handleProgress(result, onProgress).then(blob => {
						//         console.log('Blob retrieved from S3', blob);
						//         resolve({
						//             content: blob,
						//             contentType: blob.ContentType,
						//         });
						//     });
						// }).catch(error => {
						//     console.error(error);
						//     reject(error);
						// });
						// console.log('S3 Presigned Request to get file', result, getEncryptionKeysHeaders(result.encodingKey));
						callExternalApi(result.url, 'GET', null, getEncryptionKeysHeaders(result.encodingKey, result.hash), { useRawBody: true, isRaw: true }).then(response => {
							handleProgress(response, onProgress).then(blob => {
								// console.log('Blob retrieved from S3', blob);
								resolve({
									content: blob,
									contentType: blob.ContentType,
								});
							});
						}).catch(error => {
							console.error('getFileContent', error);
							notifyError(error, { filename, userId, forceContent });
							reject(error);
						});
					} else {
						resolve({
							url: result.url,
						});
					}
				} else {
					reject(new Error('noFileError'));
				}
			}).catch(error => {
				console.error('getFileContent', error);
				notifyError(error, { filename, userId, forceContent });
				reject(error);
			});
		} else {
			callApi(`file/get/${filename}`, 'get', null, { 'Content-Type': '' }, { isRaw: true }).then(response => {
				// response.blob().then(blob => {
				//     resolve({
				//         content: blob,
				//         contentType: blob.ContentType,
				//     });
				// });

				handleProgress(response, onProgress).then(blob => {
					resolve({
						content: blob,
						contentType: blob.ContentType,
					});
				});
			}).catch(error => {
				console.error('getFileContent', error);
				notifyError(error, { filename, userId, forceContent });
				reject(error);
			});
		}
	});
}

function handleProgress(responseOrReader, onProgress = null) {
	return new Promise((resolve, reject) => {
		const isStream = false && !!responseOrReader.getReader;
		const reader = isStream ? responseOrReader : responseOrReader.body.getReader();
		// Obtenir la longueur totale
		const contentLength = +(isStream ? responseOrReader.headers.get('Content-Length') : 0);
		// onProgress && console.log('handleProgress', contentLength);
		// Lecture des données
		let receivedLength = 0; // reçu autant d'octets en ce moment
		const chunks = []; // tableau de morceaux binaires reçus (comprend le corps)
		let iteration = 0;
		let prevCompletion = 0;
		reader.read().then(function processRead({ done, value }) {
			if(done) {
				onProgress && onProgress(100 - prevCompletion);
				// onProgress && console.log('File::: HandleProgress: Done');
				resolve(new Blob(chunks));
			} else {
				iteration += 1;
				// console.log('handleProgress::: Reading...');
				chunks.push(value);
				receivedLength += value.length;

				// console.log(`Received ${value.length}/${receivedLength} of total ${contentLength}`, iteration, iteration % 100 === 0);
				if(onProgress && contentLength && iteration % 100 === 0) {
					// console.log('trigger on progress', { prevCompletion, newCompletion: ((receivedLength * 100) / contentLength), difference: ((receivedLength * 100) / contentLength) - prevCompletion });
					onProgress(((receivedLength * 100) / contentLength) - prevCompletion); // : console.log(`Progress: ${contentLength ? `${(receivedLength / contentLength) * 100}%` : `${receivedLength} bytes`}`);
					prevCompletion = (receivedLength * 100) / contentLength;
				}
				reader.read().then(processRead);
			}
		});
	});
}

// export function streamFileContent(filename, userId = null) {
//     return new Promise((resolve, reject) => {
//         callApi('file/geturl', 'post', { filename, userId }).then(result => {
//             resolve(streamFile(filename, result.encodingKey));
//         }).catch(error => {
//             console.error('getFileContent', error);
//             reject(error);
//         });
//     });
// }

export function uploadFile(filename, data, contentType = '', userId = null, isPublic = false) {
	return new Promise((resolve, reject) => {
		// const formData = new FormData();
		// formData.append('userId', userId);
		// formData.append('isPublic', isPublic);
		// const filenameParts = path.split('/');
		// const filename = filenameParts.pop();
		// formData.append('files', new File([data], filename, { type: contentType })); // Create new File to set file name
		// console.log('uploadFile::: Upload', path, filename, contentType, data);
		// callApi(`file/upload/${filenameParts.join('/')}`, 'post', formData, null, { useRawBody: true, isRaw: true }).then(response => {
		//     response.json().then(result => {
		//         resolve({
		//             ...result,
		//             isOk: result.paths.includes(path),
		//         });
		//     }).catch(reject);
		// }).catch(reject);
		callApi(`file/put/url/${filename}?${userId ? `&user=${userId}` : ''}${isPublic ? '&isPublic=1' : ''}`).then(result => {
			if(result.url) {
				// s3UploadFile(filename, data, isPublic ? '' : result.encodingKey).then(result => {
				//     resolve(result);
				// }).catch(error => {
				//     console.error(error);
				//     reject(error);
				// });
				callExternalApi(result.url, 'PUT', data, result.encodingKey ? getEncryptionKeysHeaders(result.encodingKey, result.hash) : {}, { useRawBody: true, isRaw: true }).then(response => {
					resolve({ ...response, isOk: response.ok });
				}).catch(error => {
					console.error('getFileContent', error);
					notifyError(error, { filename, userId });
					reject(error);
				});
			} else {
				console.error('uploadFile::: getUrl: no url', result);
				reject(new Error('FileNoUploadUrl'));
			}
		}).catch(error => {
			console.error('uploadFile::: getUrl: catch', error);
			notifyError(error, { filename, contentType, userId, isPublic });
			reject(error);
		});
	});
}

export function getFiles(path) {
	return new Promise((resolve, reject) => {
		listFiles(path).then(result => {
			if(result) {
				resolve(result.Contents.map(content => {
					console.log(content);
					return content.Key;
				}));
			} else {
				reject(null);
			}
		}).catch(error => {
			console.error(error);
			reject(error);
		});
	});
}

export function deleteFile(path) {
	return new Promise((resolve, reject) => {
		callApi(`file/remove/${path}`, 'delete').then(result => {
			result.ok ? resolve() : reject(new Error('FileDeleteError'));
		}).catch(reject);
		// s3DeleteFile(path).then(result => {
		//     if(result) {
		//         resolve(true);
		//     } else {
		//         reject(null);
		//     }
		// }).catch(error => {
		//     console.error(error);
		//     notifyError(error, { path });
		//     reject(error);
		// });
	});
}

export function fileToBlob(file) {
	return file.arrayBuffer().then(buffer => {
		return new Blob([new Uint8Array()], { type: file.type });
	});
}
export const convertBlobToBase64 = blob => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onerror = reject;
		reader.onload = () => {
			resolve(reader.result);
		};
		reader.readAsDataURL(blob);
	});
};

export function getEncryptionKeysHeaders(encryptionKey, hash) {
	return {
		'x-amz-server-side-encryption-customer-algorithm': S3_ENCRYPTION_ALGORYTHM,
		'x-amz-server-side-encryption-customer-key': btoa(encryptionKey),
		'x-amz-server-side-encryption-customer-key-md5': hash,
	};
}
